module.exports = __webpack_public_path__ + "img/fi-rr-grid.93fd6f4d.svg";